<template>
  <div class="content-wrappper">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="row">
        <div class="col-md-8 col-sm-3 col-xs-12"><router-link class="tools-text sub_heading" to="/layout/prodclassification">
          <i class="fa fa-angle-left"></i>
        </router-link>
          <span class="heading"
            >Please provide data to start Regulatory Pathway for your medical device :</span
          >
        </div>
      </div>
      <div class="row"><div class="col-md-8 col-sm-3 col-xs-12">
          <p class="sub_caption">Is your medical device already classified? </p>
        </div></div>
      <div class="row"><div class="col-md-4 col-sm-3 col-xs-12">
      <input
        type="radio"
        id="one"
        value="DeviceAlreadyClassified"
        v-model="picked"
      />
      <label for="one">Yes</label>
        </div><div class="col-md-4 col-sm-3 col-xs-12"><input
        type="radio"
        id="two"
        value="PurchaseRRFromDashboard"
        v-model="picked"
      />
      <label for="two">No</label></div>
        </div>

        <div class="tool-container" v-if="picked === 'DeviceAlreadyClassified'">
          <div class="tool-510k col-md-4 col-xs-12 col-sm-12">
            <router-link to="/layout/prodclassification-home">
            <div class="tool-text" >
              <p class="main-content">
                Please provide all the required details for Regulatory pathway by continuing here.
              </p>
            </div>
            </router-link>
          </div>
        </div>
      <span v-if="picked === 'PurchaseRRFromDashboard'">
                  <div class="tool-container" v-if="picked === 'PurchaseRRFromDashboard'">
          <div class="tool-510k col-md-4 col-xs-12 col-sm-12">
            <router-link to="/layout/prodclassification-regpathway-home">
            <div class="tool-text" >
              <p class="main-content">
                Start with a new New Classifcation Here
              </p>
            </div>
            </router-link>
          </div>
        </div>
        <div class="tool-container" v-if="picked === 'PurchaseRRFromDashboard' && false" @click="simpleMethod">
          <div class="tool-510k col-md-4 col-xs-12 col-sm-12">
            <router-link @click="simpleMethod" to="">
            <div class="tool-text" >
              <p class="main-content">
                Completed Classification - Select from your saved classificaiton below.
              </p>
            </div>
            </router-link>
          </div>
        </div>
      </span>
      <!--<div class="row ipad-row">
            <div class="col-md-2 col-sm-2 col-xs-6 width-auto" v-for="panel in panelInfo" :key="panel.id"></div>
            <div class="col-md-10 col-sm-2 col-xs-6 width-auto" v-for="panel in panelInfo" :key="panel.id">
                <label :for="panel.id">{{panel.label}}</label>
                <input type="radio" :id="panel.id" :value="panel.id" v-model="panel_id" @change="selectPanel()">
            </div>
      </div>-->
      <div class="row" v-if="picked === 'PurchaseRRFromDashboard' && displayFlag">
        <product-classification-history-requests :userIdLoggedIn="userId"></product-classification-history-requests>
      </div>
    </div>
  </div>
</template>
<script>

import ProductClassificationHistoryRequests from './ProductClassificationHistoryRequests.vue';

export default {
  components: { ProductClassificationHistoryRequests },
  props: ['account_id', 'roleId', 'userId'],
  data() {
    return {
      picked: 'DeviceAlreadyClassified',
      rrForNewClass: false,
      displayFlag: false,
      panelInfo: [
        {
          id: 1,
          name: 'PurchaseRRForNewClassification',
          label:
            'Do you want to purchase a Rationale Report for a new Classification?',
        },
        {
          id: 2,
          name: 'PurchaseRRFromDashboard',
          label: 'No:  Please purchase from your dashaboard.',
        },
        {
          id: 3,
          name: 'rrFromDashboardForNewClass',
          label: 'No:  Please purchase from your dashaboard.',
        },
        {
          id: 4,
          name: 'rrFromDashboardForNewClass',
          label: 'No:  Please purchase from your dashaboard.',
        },
      ],
    };
  },
  methods: {
    simpleMethod() {
      this.displayFlag = true;
    },
  },
};
</script>
<style scoped>
.tool-510k{
  padding-left: 0px;
}
.tool-container {
  margin-left:10px;
}
.tool-text .main-content{
  height: 93px;
  color:#0B3C61;
}
.tool-text{
  position: relative;
  margin-top: 16px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  font-family: Roboto;
  font-size: 24px;
  line-height: 28px;
  padding: 15px 24px 16px 24px;
}
.main-content:hover:before {
  content: attr(data-hover);
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  position: absolute;
  top:0;
  left: 0;
  right: 0;
  padding: 18px 24px 0px 25px;
}
.heading {
  margin-top: 15px;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
}
.radio {
  margin-top: 0px;
}
.sub_caption {
  padding: 16px 0;
  /* width: 833px; */
  margin-bottom: 0;
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
}
.sub_heading {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
}
</style>
